import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {Relay} from '../../../classes/Relay';
import {RelayService} from '../../../services/relay.service';
import {RelayEditComponent} from '../relay-edit/relay-edit.component';
import {RelayBoard} from '../../../classes/RelayBoard';
import {RelayBoardService} from '../../../services/relay-board.service';

@Component({
  selector: 'app-relay-list',
  styleUrls: ['./relay-list.component.scss'],
  templateUrl: './relay-list.component.html',
})
export class RelayListComponent implements OnInit {

  public relays: Relay[];
  public errorMessage: string;
  private currentDialog = null;
  private relayBoards: Map<number, RelayBoard>;

  constructor(private relayService: RelayService,
              private modalService: NgbModal,
              private relayBoardService: RelayBoardService) {}

  ngOnInit(): void {
    this.updateList();

    this.relayBoardService.getAll()
      .subscribe((response: RelayBoard[]) =>
        this.relayBoards = new Map(response.map(relayBoard => [relayBoard.id, relayBoard]))
      );
  }

  private updateList(): void {
    this.relayService.getAll()
      .subscribe({
        next: (response: Relay[]) => this.relays = response,
        error: (error) => this.errorMessage = error.error.error
      });
  }

  openEditModal(relay: Relay): void {
    this.currentDialog = this.modalService.open(RelayEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-relay-edit',
        size: 'lg',
        centered: true,
      });

    this.currentDialog.componentInstance.relay = relay;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedRelay = new Relay(result.value);

          this.relayService.addOrEdit(editedRelay).subscribe({
            next: () => this.updateList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(relay: Relay): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to delete relay ' + relay.name + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.relayService.delete(relay.id).subscribe({
          next: () => this.updateList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

  getRelayBoard(relayBoardId: number): string {
    return this.relayBoards.get(relayBoardId).name;
  }
}
